























































import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase/app';
import 'firebase/auth';

@Component
export default class Login extends Vue {
    private loading: boolean = false;
    private email: string = '';
    private password: string = '';
    private error: string = '';
    private e1: boolean = true;
    private snackbar: boolean = false;
    private snackbarText: string = '';
    private snackbarColor: string = '';

    private async login() {
        try {
            this.loading = true;
            firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
                async (user) => {
                    await this.$store.dispatch('loadCompanies');
                    await this.$store.dispatch('loadNotes');
                    this.$router.push({name: 'home'});
                },
                (err) => {
                    alert(err);
                },
            );
        } catch (e) {
            this.displaySnackbar(e.message, 'error');
        } finally {
            this.loading = false;
        }
    }

    private displaySnackbar(msg: string, color: string) {
        this.snackbarText = msg;
        this.snackbarColor = color;
        this.snackbar = true;
    }
}
